import { useState } from 'react';
import { MajorMaintenance } from '@/reports/sections/VehicleMaintenanceSchedule/MajorMaintenance';
import { RoutineMaintenance } from '@/reports/sections/VehicleMaintenanceSchedule/RoutineMaintenance';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { AutomobileMaintenanceSchedules } from '@/reports/types/vehicles';

interface VehicleMaintenanceScheduleProps {
  vehicleMaintenanceSchedules: AutomobileMaintenanceSchedules;
}

export function VehicleMaintenanceSchedule({
  vehicleMaintenanceSchedules,
}: VehicleMaintenanceScheduleProps) {
  const [isSevereDriving, setIsSevereDriving] = useState<boolean>(false);

  const [routineMaintenance, majorMaintenance] = ['EVERY', 'AT'].map(
    (maintenanceInterval) => {
      return filterMaintenanceSchedules(
        vehicleMaintenanceSchedules,
        isSevereDriving,
        maintenanceInterval
      );
    }
  );

  const hasSevereDrivingItems = vehicleMaintenanceSchedules.some(
    (schedule) =>
      schedule.schedule_name?.toUpperCase() === 'SEVERE MAINTENANCE SCHEDULE'
  );

  const hasRoutineMaintenanceItems = vehicleMaintenanceSchedules.some(
    (schedule) => {
      return schedule.intervals?.some(
        (interval) => interval.type?.toUpperCase() === 'EVERY'
      );
    }
  );

  const hasMajorMaintenanceItems = vehicleMaintenanceSchedules.some(
    (schedule) => {
      return schedule.intervals?.some(
        (interval) => interval.type?.toUpperCase() === 'AT'
      );
    }
  );

  return (
    <ReportSection
      showTopBar
      title="Maintenance Schedule"
      hasContent={vehicleMaintenanceSchedules.length > 0}
      sectionId="vehicle-maintenance-schedule"
      customEmptyText={
        <EmptyVehicleSectionDisclaimer title="maintenance schedule" />
      }
    >
      {hasRoutineMaintenanceItems && (
        <RoutineMaintenance
          vehicleMaintenanceSchedules={routineMaintenance}
          isSevereDriving={isSevereDriving}
          setIsSevereDriving={setIsSevereDriving}
          hasSevereDrivingItems={hasSevereDrivingItems}
        />
      )}
      {hasMajorMaintenanceItems && (
        <MajorMaintenance
          vehicleMaintenanceSchedules={majorMaintenance}
          isSevereDriving={isSevereDriving}
          setIsSevereDriving={setIsSevereDriving}
          hasSevereDrivingItems={hasSevereDrivingItems}
        />
      )}
    </ReportSection>
  );
}

function filterMaintenanceSchedules(
  schedules: AutomobileMaintenanceSchedules,
  severeDriving: boolean,
  type: string
) {
  return schedules.filter((schedule) => {
    return (
      ((severeDriving &&
        schedule.schedule_name?.toUpperCase() ===
          'SEVERE MAINTENANCE SCHEDULE') ||
        (!severeDriving &&
          schedule.schedule_name?.toUpperCase() !==
            'SEVERE MAINTENANCE SCHEDULE')) &&
      schedule.intervals?.some(
        (interval) => interval.type?.toUpperCase() === type
      )
    );
  });
}
